"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LegalOverview() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="137769" id="legal-notice-overview" className="bg-background text-foreground">
      <div className="bg-[#0E1624] w-full pt-40 pb-24 md:pb-32 lg:pb-40 px-6 md:px-12 overflow-hidden border-t border-[#5C6670]/40">
        <div className="max-w-7xl mx-auto flex flex-col items-start">
          <h1 ref={headerRef} className={`font-serif font-bold text-white text-4xl md:text-[48px] leading-none tracking-tight mb-12 md:mb-20 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            LEGAL NOTICE
          </h1>

          <div ref={textRef} className={`relative pl-6 md:pl-10 max-w-[600px] transition-all duration-1000 delay-300 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            {}
            <div className={`absolute left-0 top-0 bottom-0 w-[2px] bg-primary transition-transform duration-1000 delay-700 ease-out origin-top ${isTextVisible ? "scale-y-100" : "scale-y-0"}`} />

            <div className="space-y-6">
              <p className="font-mono text-xs text-primary tracking-widest uppercase mb-4">
                DOC_REF: VN-2024-LEGAL
              </p>
              <p className="text-white/70 text-lg leading-relaxed font-sans">
                This document provides the formal legal framework governing our maritime logistics operations and digital services. It outlines the regulatory compliance standards and professional ethics that define our commitment to global trade integrity.
              </p>
              <p className="text-white/70 text-lg leading-relaxed font-sans">
                By accessing our platforms and engaging with our supply chain solutions, users acknowledge and agree to the terms specified herein. We maintain these standards to ensure transparency across all international jurisdictions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}